import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const pendingApprovalCountKey = (businessId: string | null | undefined) =>
  ["pending-approvals-count", businessId] as const;

/**
 * Everything waiting in the business's approval queue: the same count the
 * approval reminder email reports, and what the Approvals page lists.
 * Refetches every minute; approve/reject handlers also invalidate it.
 */
export function usePendingApprovalCount(businessId: string | null | undefined): number {
  const { data = 0 } = useQuery({
    queryKey: pendingApprovalCountKey(businessId),
    queryFn: async () => {
      if (!businessId) return 0;
      const { count, error } = await supabase
        .from("action_approval_queue")
        .select("id", { count: "exact", head: true })
        .eq("business_id", businessId)
        .eq("status", "pending");
      if (error) throw error;
      return count ?? 0;
    },
    enabled: !!businessId,
    refetchInterval: 60_000,
  });
  return data;
}
